import {Expose} from "class-transformer";

export interface ImportResponseStatsItem {
  created?: number;
  updated?: number;
  skiped?: number;
  errors?: number;
}

export type ImportResponseStats<T extends string = string> = {
  [K in T]?: ImportResponseStatsItem;
}

export class ImportResponse<T extends string = string> {
  @Expose({ name: 'errors' })
  errors!: Record<number, string[]>;
  @Expose({ name: 'stats' })
  stats!: ImportResponseStats<T>;
}
